import { TuiDayRange } from "@taiga-ui/cdk";

export type DatesAndAccupancy = {
    range: TuiDayRange,
    adultes: number,
    children: number,
    ages: Array<null | number>,
    rooms: number,
    currency: string
}

export type WidgetDetail = {
  scwdId: string;
  scwdEngine: string;
  scwdIsEnabled: "0" | "1";
};

export type WidgetData = {
    id: number;
    code: string;
    hotel: string;
    country: string;
    position: number;
    theme: string;
    id_booking: number;
    id_hotel_in_bo: number;
    checkprice: string | null;
    color: string | null;
    currency: string;
    detail: {
      scwId: string;
      scwIsEnabled: "0" | "1";
      scwHasComment: "0" | "1";
      scwHasBook: "0" | "1";
      listOta: string[];
      idb: string;
      etabType: string;
      etabMinAge: string;
      etabMaxAge: string;
      etabHasChild: "0" | "1";
    };
    widgetDetail?: WidgetDetail[];
  };

export type HotelBookingAPIResp = {
  status: number;
  response: HotelBookingData;
};

export type HotelBookingDataDetails = {
  name_room_ota: string;
  hotel_id: string;
  ota: string;
  type_map: number;
  roomtype_ota: {
    room_name: string;
    items: Array<{
      reg: string;
      item_name: string;
      values: {
        val1?: string;
        val2?: string;
      } | [];
    }>;
    sleeps: string;
  };
  roomtype_wik: string[];
  code_room: number;
  metrage: null;
  code_meal_paln: number;
  code_sale_condition: number;
  code_occupancy: number;
  code_children: number;
  searchedby: string;
  price_html: string;
  price_desplayed: number;
  price: number;
  ttc: number;
  ht: number;
  ht_without_promo: number;
  ttc_without_promo: number;
  currency: string;
  promottcht: string;
  offer_freebreakfast: boolean;
  offer: {
    [date: string]: {
      price_day_final: number;
      price_day: number;
      genius_price_day_final: number;
      genius: Array<{
        id: number;
        offer_type: string;
        pourcentage: number;
        pourcentage_type: string;
        day_name: string;
        price_day_promo: number;
      }>;
    };
  };
  stock: number;
  exchange_rate: number;
  tax_exc_engine: {
    tva: number;
    taxedesejour: number;
  };
  tax_inc_engine: any[];
  tax_in: boolean;
  tax_exc_engine_without_promo: {
    tva: number;
    taxedesejour: number;
  };
  tax_inc_engine_without_promo: any[];
  tax_wh: Array<{
    txName: string;
    txMontant: number;
    txFormule: number;
    txTypeMontant: number;
    txInc: boolean;
  }>;
  code_ltid: null;
  uid: string;
  isbookingbasic: boolean;
  serial: string;
  conditions_details: {
    condition: {
      annulation: {
        type: string;
        typeAnnulation: number;
        intervals: Array<{
          d: number;
          a: number | string;
          p: number;
          "an-fn": number;
        }>;
      };
      "no-show": {
        checked: boolean;
        percent: number;
        "stay-firstnight": number;
      };
      prepayment: {
        checked: boolean;
        percent: number;
        "stay-firstnight": number;
        date: null;
      };
      reschedule: {
        checked: boolean;
        date: null;
      };
    };
    description: string;
  };
  rooms_literie: null;
  addedvalues: Array<{
    category: string;
    name: string;
    values: {
      val1?: string;
      val2?: string;
    } | [];
    sorting: number;
    idbo: null;
  }>;
  garantie: boolean;
  code_ltdid: null;
  room_upgrade: number;
  room_upgrade_to: null;
  is_partner: boolean;
  plusadult: number;
  child: string;
  isGoogleHotelAds: boolean;
  prixOLD2: number;
  detailPrice: {
    Ttc: number;
    priceDesplayed: number;
    Sale: number;
    HT: number;
    TaxeExc: number;
    TaxeInc: number;
    details: {
      inc: any[];
      exc: {
        tva: {
          name: string;
          montant: number;
        };
        taxedesejour: {
          name: string;
          montant: number;
        };
      };
    };
  };
  detailPrice_without_promo: {
    Ttc: number;
    priceDesplayed: number;
    Sale: number;
    HT: number;
    TaxeExc: number;
    TaxeInc: number;
    details: {
      inc: any[];
      exc: {
        tva: {
          name: string;
          montant: number;
        };
        taxedesejour: {
          name: string;
          montant: number;
        };
      };
    };
  };
  ocupation: string;
  ttc_without_promoOLD: number;
  tax: {
    inc: any[];
    exc: Array<{
      txName: string;
      txMontant: number;
      txFormule: number;
      txTypeMontant: number;
      txInc: boolean;
      txMontantDisplay: number;
      txIssejour: boolean;
    }>;
  };
  conditiondetail: {
    prepaye: {
      checked: boolean;
      type: boolean;
      nbr: number;
    };
    show: {
      checked: boolean;
      type: boolean;
      nbr: number;
    };
    annulation: {
      type: number;
      isHeur: boolean;
      detail: Array<{
        from: number;
        to: number | null;
        crFarisPercent: number;
        crFarisType: boolean;
      }>;
    };
  };
  ltId: number;
  indexSearch: string;
}

export type HotelBookingData = {
  engine: Record<string, HotelBookingDataDetails>;
  enginesearch: string;
  bestPrices: {
    bestprice: HotelBookingDataDetails | null;
    googleHotelAds: HotelBookingDataDetails | null;
    partner: HotelBookingDataDetails | null;
  };
  warrings: {
    extraDispo: {
      message: string;
      httpCode: number;
      content: string;
    };
  };
  rooms_recommended: any[];
  urls: Array<{
    url: string;
    timestamp: number;
  }>;
  otaEnvEtab: number;
  token: string;
}

export type HotelBookingRequest = {
  start_date: string;
  end_date: string;
  devise: string;
  adults: number;
  enfants: number;
  device: string;
  type: string;
  ip?: string;
  tokenSearch: string;
  idbackoffice: number;
  engine?: string;
  agesenfants: Array<number|null>
};

export type Proposition = {
  startDate: string;
  endDate: string;
  nights: number;
  price: {
    currency: string;
    amount: number;
  };
};

export const ENGINES_TRANSLATIONS: any = {
  "b.googleHotelAds": "asseenongoogle",
  "b.bestprice": "booking",
  "a.bestprice": "agoda",
  "a.partner": "partneroffer",
  "bc.bestprice": "fidelity",
  "so.bestprice": "tarifstandard"
}

export const NO_IMAGE = 'https://rate.picscache.com/sitesAllInOne/Assets_IQScan/svg/logo_not_found.svg';

export type ImagesData = {
  baseurl: string;
  data: DataInfo[];
  rooms: RoomInfo[];
}

type RoomInfo = {
  id_chambre: number;
  title_chambre: string;
  img: string[]
}

type DataInfo = {
  overridelignename: string | null;
  traductiondetail: string;
  img: string[];
  rate_cond_categ: string;
  is_booking_basic:  "0" | "1";
  title_condition: string;
  serial: string | null;
  id_linetarifaire: number;
  roomerase: number;
  nbpax_de_base: string;
  id_chambre: number;
  title_chambre: string;
  parent: number;
  title_linetarifaire: string;
};